<script setup>
import { ref } from 'vue';

const emit = defineEmits(['update:modelValue', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const statuses = [
    { title: 'Subscriber', value: 'Subscriber' },
    { title: 'Pobox', value: 'Pobox' },
    { title: 'Guide', value: 'Guide' },
    { title: 'Bill', value: 'Bill' },
    { title: 'Receipt', value: 'Receipt' },
    { title: 'Adservice', value: 'Adservice' },
    { title: 'Alert', value: 'Alert' },
    { title: 'Consolidated', value: 'Consolidated' },
    { title: 'WHrec', value: 'WHrec' },
    { title: 'NotaEntrega', value: 'NotaEntrega' },
    { title: 'ValueDeclaration', value: 'ValueDeclaration' },
    { title: 'Liquidación', value: 'Liquidación' },
    { title: 'BL', value: 'BL' },
    { title: 'Pickup', value: 'Pickup' },
    { title: 'AWB', value: 'AWB' },
    { title: 'Agent', value: 'Agent' }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="hideLabel ? '' : $t('Associated')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
